import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconInfo = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833252 8C0.833252 4.04196 4.04188 0.833336 7.99992 0.833336C11.958 0.833336 15.1666 4.04196 15.1666 8C15.1666 11.958 11.958 15.1667 7.99992 15.1667C4.04188 15.1667 0.833252 11.958 0.833252 8ZM7.99992 1.83334C4.59416 1.83334 1.83325 4.59425 1.83325 8C1.83325 11.4058 4.59416 14.1667 7.99992 14.1667C11.4057 14.1667 14.1666 11.4058 14.1666 8C14.1666 4.59425 11.4057 1.83334 7.99992 1.83334Z"
      fill="#7B7B8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33325 6.83334C8.60939 6.83334 8.83325 7.05719 8.83325 7.33334L8.83325 11.3333C8.83325 11.6095 8.60939 11.8333 8.33325 11.8333C8.05711 11.8333 7.83325 11.6095 7.83325 11.3333L7.83325 7.33334C7.83325 7.05719 8.05711 6.83334 8.33325 6.83334Z"
      fill="#7B7B8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83325 7.33334C8.83325 7.60948 8.60939 7.83334 8.33325 7.83334L6.99992 7.83334C6.72378 7.83334 6.49992 7.60948 6.49992 7.33334C6.49992 7.05719 6.72378 6.83334 6.99992 6.83334L8.33325 6.83334C8.60939 6.83334 8.83325 7.05719 8.83325 7.33334Z"
      fill="#7B7B8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33325 4.16667C8.60939 4.16667 8.83325 4.39053 8.83325 4.66667L8.83325 5.33334C8.83325 5.60948 8.60939 5.83334 8.33325 5.83334C8.05711 5.83334 7.83325 5.60948 7.83325 5.33334L7.83325 4.66667C7.83325 4.39053 8.05711 4.16667 8.33325 4.16667Z"
      fill="#7B7B8E"
    />
  </SvgIcon>
)
